(function(Drupal, $, once){
    Drupal.behaviors.contact_form = {
        attach() {
            $(once('contact_webform', '.contact-webform')).each(function() {
                $(".contact_form__toggle-js").click(function () {

                    var isOpen = $(this).data('show');

                    if (!isOpen) {
                        $(this).closest('.contact-webform').find('.contact-webform__container-js').addClass('opened');
                    } else {
                        $(this).closest('.contact-webform').find('.contact-webform__container-js').removeClass('opened');
                    }

                    isOpen = !isOpen;
                    $(this).data('show', isOpen).text(`${isOpen ? 'Close' : 'Open'}`);
                });
            });
        }
    };

    Drupal.behaviors.custom_dropdown = {
        attach() {
            /* Custom Advanced checkboxes fieldset dropdown behaviour */

            const dropdown_parent_element = '.filter_dropdown-js';

            const $dropdown_element = $(dropdown_parent_element);

            if ($dropdown_element.length) {

                // Add scrollbar if more than 6 options available.
                $($dropdown_element).each(function () {
                    const $options = $(this).find('.js-form-type-checkbox');
                    let legendID = $(this).closest($dropdown_element).find('.fieldset-legend').attr('id');
                    const enterKeyCode = 13;

                    if ($options.length > 6) {
                        $options.wrapAll('<div class="scrollbar-macosx"/>');
                    }
                    $options.wrapAll(`<ul role="listbox" aria-labelledby="${legendID}"/>`);
                    $options.find("input").attr("tabIndex", "-1");
                    $options.keypress(function(e){
                        if (e.keyCode === enterKeyCode) {
                            $(this).find('input').click();
                        }
                    });
                });

                $dropdown_element.find('legend').off().click(toggleDropdown);
                $dropdown_element.keypress(toggleDropdown);
            }

            function toggleDropdown() {
                const $clicked_element = $(this);
                if ($clicked_element.closest(dropdown_parent_element).hasClass('opened')) {
                    $(this).closest(dropdown_parent_element).removeClass('opened').find('.fieldset-wrapper').fadeOut();
                } else {
                    $dropdown_element.closest(dropdown_parent_element).removeClass('opened').find('.fieldset-wrapper').fadeOut();
                    $(this).closest(dropdown_parent_element).addClass('opened').find('.fieldset-wrapper').fadeIn();
                    $(this).closest(dropdown_parent_element).find(".js-form-type-checkbox").first().focus();
                }
            }


            const $checkboxes = $('.toolkit-filters .checkbox-set input:checkbox');

            function determineChecked($element) {
                if ($element.is(':checked')) {
                    $element.prev().addClass('checked');
                } else {
                    $element.prev().removeClass('checked');
                }
            }

            $checkboxes.each((el) => determineChecked($($checkboxes.get(el))));

            $checkboxes.change(
                function(){
                    determineChecked($(this));
                });
        }
    };

    Drupal.behaviors.dropdown_scrollbar = {
        attach() {

            const target = '.filter_dropdown-js .scrollbar-macosx';

            // Implements the jquery_scrollbar library for mac style scrollbar.
            $(once('dropdown_scrollbar', target)).scrollbar();

        }
    };

    Drupal.behaviors.topic_form = {
        attach: function () {

            /* Topic form */
            const $topic_form = $('#ukho-topic-form');
            const $form_toggle_btn = $('#add-topic-btn');

            $form_toggle_btn.off('click').on('click', function() {
                $form_toggle_btn.toggleClass('icon--plus');
                $form_toggle_btn.toggleClass('icon--close-solid');
                $topic_form.slideToggle();
            });

        }
    };

    Drupal.behaviors.checkout_form = {
        attach: function() {
            const $countryCode = $('div[data-drupal-selector="edit-billing-information-profile-address-0-address-country-code"]');
            if ($countryCode.length) {
                $countryCode.appendTo($countryCode.parent());
            }
        }
    }

    Drupal.behaviors.quantity_counter = {
        attach: function () {

            $(once('quantity_counter', 'body')).first().each(function() {
                const decrementButtons = $('[data-action="decrement"]');
                const incrementButtons = $('[data-action="increment"]');

                function decrement(el) {
                    const numberInput = el.siblings("input[type=number]");
                    let value = numberInput.val();
                    if (value >= 2) {
                        value--;
                        numberInput.val(value);
                    }
                }
                function increment(el){
                    const numberInput = el.siblings("input[type=number]");
                    let value = numberInput.val();
                    value++;
                    numberInput.val(value);
                }

                $(document).on('click', '[data-action="increment"]', function (event) {
                    increment($(this));
                });
                $(document).on('click', '[data-action="decrement"]', function (event) {
                    decrement($(this));
                });
            });
        }
    }
})(Drupal, jQuery, once);

